// extracted by mini-css-extract-plugin
export default {"box":"BoxComponent_box__8LES9","image":"BoxComponent_image__7l1rP","description":"BoxComponent_description__vIVi+","extraMargin":"BoxComponent_extraMargin__YBqZQ"};